export default "__VITE_ASSET__BQzY6tq9__"